export default __webpack_public_path__ + "static/media/groups.de235421.png";